<template>
  <div>
    <v-dialog width="800" v-model="showchange">
      <template v-slot:activator="{ on }">
        <v-btn
          flat
          outline
          class=" mr-2"
          :style="`line-height: 10px;`"
          v-on="on"
          v-if="!$store.state.isFacebook"
          color="white"
          >{{ $t('Change Password') }}</v-btn
        >
      </template>
      <v-card v-if="showchange">
        <v-container>
          <v-card-text>
            <h3 class="mb-2">{{ $t('Change Password') }}</h3>
            <div class="mb-2" :class="{ 'has-error': errors.has('password') }">
              <v-text-field
                :label="$t('New password')"
                v-validate="'required'"
                name="password"
                type="password"
                :data-vv-as="$t('password')"
                v-model.trim="password"
                autocomplete="on"
                ref="password"
                :hide-details="!errors.has('password')"
                :error="errors.has('password')"
                :error-messages="errors.first('password')"
                outline
              ></v-text-field>
            </div>
            <div class="mb-2" :class="{ 'has-error': errors.has('passwordconfirm') }">
              <v-text-field
                :label="$t('Confirm password')"
                v-validate="'required|confirmed:password'"
                name="passwordconfirm"
                :data-vv-as="$t('password')"
                type="password"
                autocomplete="on"
                v-model.trim="confirmpassword"
                :hide-details="!errors.has('passwordconfirm')"
                :error="errors.has('passwordconfirm')"
                :error-messages="errors.first('passwordconfirm')"
                outline
              ></v-text-field>
            </div>
            <div class="text-xs-center">
              <v-btn @click="cancel" outline color="grey">{{ $t('cancel') }}</v-btn>
              <v-btn
                @click="changepassword"
                :loading="loading"
                :disabled="loading"
                depressed
                color="primary"
                >{{ $t('Save') }}</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      showchange: false,
      loading: false,
      password: '',
      confirmpassword: ''
    }
  },
  computed: {
    ...mapGetters(['isFacebook', 'currentLang'])
  },
  methods: {
    cancel() {
      //   this.password = ''
      //   this.confirmpassword = ''
      this.showchange = false
    },
    changepassword() {
      var vm = this
      var data = { adminid: this.$store.state.userid, password: this.confirmpassword }

      this.loading = true
      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          return false
        }

        api.changepassword(data, (error, response) => {
          if (error) console.error(error)
          this.loading = false
          if (response.responsecode == 200) {
            vm.$swal
              .fire({
                type: 'success',
                title: vm.$t('Success')
              })
              .then(() => {
                vm.$store.dispatch('logout', null).then(() => {
                  vm.$router.push('/' + vm.currentLang + '/login')
                })
              })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/ChangePassword.vue